var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleOriginal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6684 17.3916C33.6684 16.236 33.5747 15.0741 33.3748 13.9373H17.3398V20.4836H26.5223C26.1413 22.595 24.9169 24.4627 23.1242 25.6495V29.8972H28.6024C31.8194 26.9363 33.6684 22.5637 33.6684 17.3916Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3401 34.0012C21.925 34.0012 25.7917 32.4958 28.6089 29.8972L23.1306 25.6496C21.6065 26.6865 19.6388 27.2737 17.3463 27.2737C12.9113 27.2737 9.15083 24.2816 7.80157 20.2588H2.14844V24.6376C5.03435 30.3782 10.9124 34.0012 17.3401 34.0012Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79511 20.2587C7.083 18.1474 7.083 15.8611 7.79511 13.7498V9.37097H2.14822C-0.262949 14.1746 -0.262949 19.8339 2.14822 24.6375L7.79511 20.2587Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3401 6.72868C19.7637 6.69121 22.1062 7.6032 23.8615 9.27728L28.715 4.42371C25.6417 1.5378 21.5627 -0.0488268 17.3401 0.00114561C10.9124 0.00114561 5.03435 3.62415 2.14844 9.37098L7.79532 13.7498C9.13833 9.72079 12.905 6.72868 17.3401 6.72868Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleOriginal);
export default __webpack_public_path__ + "static/media/Google - Original.97526f78c5850984737aa82668c4c3f4.svg";
export { ForwardRef as ReactComponent };